(function() {
  function onReady(fn) {
    document.addEventListener("turbolinks:load", fn);
  }

  onReady(function initDeletePages() {
    var form = document.getElementById("deletePagesForm");
    if (!form || form.dataset.bound === "true") return;
    form.dataset.bound = "true";

    var max = parseInt(form.dataset.pageCount || "0", 10);
    var isSection = form.dataset.isSection === "true";

    var pdfFrame      = document.getElementById("pdfFrame");
    var selectedEl    = document.getElementById("selectedCount");
    var rangeInput    = document.getElementById("rangeInput");
    var applyRangeBtn = document.getElementById("applyRangeBtn");
    var deleteBtn     = document.getElementById("deleteSubmitBtn");
    var pagesGrid     = document.getElementById("pagesGrid");
    var placeholder   = document.getElementById("pagesGridPlaceholder");

    function checkboxes() {
      return Array.from(document.querySelectorAll(".page-checkbox"));
    }

    function selectedPages() {
      return checkboxes()
        .filter(function(cb){ return cb.checked; })
        .map(function(cb){ return parseInt(cb.dataset.page || cb.value, 10); })
        .filter(function(n){ return !isNaN(n); });
    }

    function updateCount() {
      if (selectedEl) selectedEl.textContent = selectedPages().length;
    }

    function parseRanges(input) {
      var set = new Set();
      if (!input) return set;
      input.split(",").forEach(function(part) {
        part = part.trim();
        if (!part) return;
        var m = part.match(/^(\d+)\s*-\s*(\d+)$/);
        if (m) {
          var a = Math.max(1, Math.min(max, parseInt(m[1], 10)));
          var b = Math.max(1, Math.min(max, parseInt(m[2], 10)));
          if (a > b) { var t = a; a = b; b = t; }
          for (var i = a; i <= b; i++) set.add(i);
        } else {
          var n = Math.max(1, Math.min(max, parseInt(part, 10)));
          if (!isNaN(n)) set.add(n);
        }
      });
      return set;
    }

    function renderCheckboxesForPages(pageNumbers) {
      if (!pagesGrid) return;
      pagesGrid.innerHTML = '';

      if (pageNumbers.length === 0) {
        var p = document.createElement('p');
        p.className = 'text-muted mb-0 w-100';
        p.textContent = 'Enter a range above and click Apply to show pages for selection.';
        pagesGrid.appendChild(p);
        updateCount();
        return;
      }

      var sorted = Array.from(pageNumbers).sort(function(a, b) { return a - b; });
      sorted.forEach(function(pg) {
        var wrapper = document.createElement('div');
        wrapper.className = 'form-check mr-3 mb-2';
        wrapper.style.minWidth = '70px';

        var cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.name = 'plan_amendment[delete_pages][]';
        cb.value = pg;
        cb.id = 'page_' + pg;
        cb.className = 'form-check-input page-checkbox';
        cb.dataset.page = pg;
        cb.checked = true;
        cb.addEventListener('change', updateCount);

        var lbl = document.createElement('label');
        lbl.htmlFor = 'page_' + pg;
        lbl.className = 'form-check-label page-label';
        lbl.dataset.page = pg;
        lbl.textContent = pg;

        var viewBtn = document.createElement('button');
        viewBtn.type = 'button';
        viewBtn.className = 'btn btn-link btn-sm p-0 ml-1 view-page-btn';
        viewBtn.dataset.page = pg;
        viewBtn.title = 'View page ' + pg;
        viewBtn.innerHTML = '&#x1F441;';
        viewBtn.addEventListener('click', function() {
          viewPageNumber(parseInt(this.dataset.page, 10));
        });

        wrapper.appendChild(cb);
        wrapper.appendChild(lbl);
        wrapper.appendChild(viewBtn);
        pagesGrid.appendChild(wrapper);
      });

      updateCount();
    }

    function viewPageNumber(n) {
      if (!isNaN(n) && n >= 1 && n <= max) {
        if (window._deletePageViewer) {
          window._deletePageViewer.goToPage(n);
        } else if (pdfFrame) {
          var base = pdfFrame.src.split("#")[0];
          pdfFrame.src = base + "#page=" + n + "&zoom=page-fit";
        }
      }
    }

    form.addEventListener("keydown", function(e) {
      if (e.key === "Enter" && e.target && e.target.tagName !== "TEXTAREA") {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    function applyRange() {
      var set = parseRanges(rangeInput && rangeInput.value);
      renderCheckboxesForPages(set);
    }

    if (applyRangeBtn) applyRangeBtn.addEventListener("click", applyRange);

    if (rangeInput) rangeInput.addEventListener("keydown", function(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        applyRange();
      }
    });

    var byId = function(id){ return document.getElementById(id); };
    var wire = function(id, fn){ var el = byId(id); if (el) el.addEventListener("click", fn); };

    wire("selectAllBtn",  function(){
      var set = new Set();
      for (var i = 1; i <= max; i++) set.add(i);
      renderCheckboxesForPages(set);
    });
    wire("clearAllBtn", function(){
      checkboxes().forEach(function(cb){ cb.checked = false; });
      updateCount();
    });
    wire("invertBtn", function(){
      checkboxes().forEach(function(cb){ cb.checked = !cb.checked; });
      updateCount();
    });
    wire("oddBtn", function(){
      var set = new Set();
      for (var i = 1; i <= max; i += 2) set.add(i);
      renderCheckboxesForPages(set);
    });
    wire("evenBtn", function(){
      var set = new Set();
      for (var i = 2; i <= max; i += 2) set.add(i);
      renderCheckboxesForPages(set);
    });
    wire("first10Btn", function(){
      var set = new Set();
      for (var i = 1; i <= Math.min(10, max); i++) set.add(i);
      renderCheckboxesForPages(set);
    });
    wire("last10Btn", function(){
      var set = new Set();
      var start = Math.max(1, max - 9);
      for (var i = start; i <= max; i++) set.add(i);
      renderCheckboxesForPages(set);
    });

    updateCount();

    if (deleteBtn) {
      deleteBtn.addEventListener("click", function() {
        var chosen = selectedPages();

        if (chosen.length === 0) {
          alert("Please select at least one page to delete.");
          return;
        }

        var msg;
        if (max > 0 && chosen.length === max) {
          if (isSection) {
            alert("You cannot delete all pages of this section.");
            return;
          }
          msg = "You selected ALL " + max + " pages.\n\nThis will delete the entire plan. Continue?";
        } else {
          var count  = chosen.length;
          var sample = count <= 10 ? chosen.join(", ") : (chosen.slice(0, 10).join(", ") + "\u2026");
          msg = "Delete " + count + " page" + (count > 1 ? "s" : "") + " (" + sample + ")?";
        }

        if (!window.confirm(msg)) return;

        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
  });
})();
